import React from "react";
import { useEffect,useState } from "react";
import { Helmet } from "react-helmet";
import "./Single.css";
import ScholarshipProgramme from "../animation/ScholarshipProgramme";
// import { Underline } from "../section/Underline";
import WOW from 'wowjs';


export const Single = () => {

  const [expandedSections, setExpandedSections] = useState({
    aboutProgram: false,
    enhancingEmployability: false,
    skillEnhancement: false,
    higherEducation: false,
    hospitality: false,
    others: false
  });
// Function to toggle section expansion
const toggleSection = (sectionKey) => {
  setExpandedSections(prev => ({
    ...prev,
    [sectionKey]: !prev[sectionKey]
  }));
};

// Function to truncate text
const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};


  useEffect(() => {
    // Initialize WOW.js
    new WOW.WOW({
      live: false
    }).init();
  }, []);
  return (
    <>
      <Helmet>
        <title>What we Do | Joining Hands</title>
      </Helmet>

      <main>
        {/* <!-- Page banner area start here --> */}
        <section
          class="banner__inner-page bg-image pt-160 pb-160 bg-image"
          style={{
            backgroundImage: "url('/images/banner/gallery.jpg')",
            position: "relative",
          }}
        >
          <div
            className="overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(1, 0, 0, 0.5)",
            }}
          ></div>
          <div class="container overlay_content">
            <h2
              class="wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              What We Do
            </h2>

            <div
              class="breadcrumb-list wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <a href="index.html">Home</a>
              <span className="text-white">
                <i class="fa-regular fa-angles-right mx-2"></i>What We Do
              </span>
            </div>
          </div>
        </section>
        {/* <!-- Page banner area end here --> */}
        {/* ---------------------about us programmer------ */}
           <section class="blog-single-area pt-50 pb-120 ">
          <div class="container">
            <div class="row g-4">
              <div class="col-lg-12 order-2 order-lg-1">
                <div class="blog__item blog-single__left-item shadow-none">
                  <div class="blog__content p-0 mt-20 wow fadeInDown ">
                    {/* <h4 class="mt-20 mb-20  py-5 fs-30 fw-bold text-center">
                      Enhancing Employability
                    </h4> */}
                    <div className="row align-items-center ">
                    <div
                        className="col-md-5 image_box "
                        style={{ padding: "0 12px" }}
                        >
                        <img src="/images/project/other-6.jpg" alt="" />
                        {/* <span className="blog-tag">{tag}</span> */}
                      </div>

                      <div className="col-md-7 ">
                        <h4 class="mt-20   fs-30 fw-bold ">
                          About the Program
                        </h4>
                        <div className=" pr-30">
                        <div className="content-wrapper">
                        {expandedSections.aboutProgram ? (
                              <>
                          <p class=" mb-2 mt-20  fw-500 text-justify">
                          Our program has a multi fold approach, it involves parents, students, teachers, employers hence creating a multistakeholder style. All the stakeholders come in at various steps of the program, like mobilizing, training, placements & post placement support. Each level is embedded with modules that create a pathway for youth of marginalized communities to enhance their skills, understand their strengths and work on their bright future. Each passing batch of the programs leaves us with more and unique learnings, about the economic environment, all pervasive invasion of online especially post-covid, changing behavior of the retail industry, all go on to become factors that keep our learning curve ever evolving and steep. 
 
                          </p>
                          <p class="mb-2  fw-500 text-justify">
                         <b>  We extended our reach to providing specialized sector-based training and aiding in higher education and professional courses to the beneficiaries.</b> Over the years our team has understood the major roadblocks that this section of the society faces and we are constantly involved in clearing the path for a better future for them. We work towards making the underprivileged youth more useful to society and their families by training them with skills that can make them employable and self-reliant. Our programs are specially curated to provide specialized training and suitable jobs to these youth. We also extend our support to students completing higher education and professional courses. It is our endless endeavor to create a skilled and trained workforce. 
                          </p>
                          <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read Less
                                </button>
                              </>
                          ):(
                            <>
                                <p class="mb-2 mt-20 fw-500 text-justify">
                                  {truncateText("Our program has a multi fold approach, it involves parents, students, teachers, employers hence creating a multistakeholder style. All the stakeholders come in at various steps of the program, like mobilizing, training, placements & post placement support. Each level is embedded with modules that create a pathway for youth of marginalized communities to enhance their skills, understand their strengths and work on their bright futureEach passing batch of the programs leaves us with more and unique learnings, about the economic environment, all pervasive invasion of online especially post-covid, changing behavior of the retail industry, all go on to become factors that keep our learning curve ever evolving and steep...", 900)}
                                </p>
                                <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read More
                                </button>
                              </>
                            )}
                          
                         </div >
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --------------------- end about us programmer------ */}
           



        {/* ---------------------Enhancing Employability------ */}
        <section class="blog-single-area pt-50 pb-120 sub-bg">
          <div class="container">
            <div class="row g-4">
              <div class="col-lg-12 order-2 order-lg-1">
                <div class="blog__item blog-single__left-item shadow-none">
                  <div class="blog__content p-0 mt-20 wow fadeInDown ">
                    {/* <h4 class="mt-20 mb-20  py-5 fs-30 fw-bold text-center">
                      Enhancing Employability
                    </h4> */}
                    <div className="row align-items-center ">
                      <div className="col-md-7 ">
                        <h4 class="mt-20   fs-30 fw-bold ">
                          Enhancing Employability
                        </h4>
                        <div className=" pr-30">
                         <div className="content-wrapper">
                         {expandedSections.aboutProgram ? (
                              <>  
                          <p class=" mb-2 mt-20  fw-500 text-justify">
                          We started with a vision to create employable urban youth that can play an integral part in the financial machinery of their family and society at large. This visualization gave rise to two flagship programs of joining hands, “Skill Enhancement Program” & “Higher Education Scholarship program”. Both these programs are dedicated to carve a righteous path for underprivileged youth that can save them from the social vices. We are very responsive to the changing market scenario and industry specific standards. Our programs are designed in a way that is in complete sync with industry standards and are research based, that give transparency in all aspects. 
                          </p>
                          <p class="mb-2  fw-500 text-justify">
                            <b>At joining hands, we not only make sure that meritorious youth can continue their higher education   without the major roadblock of financial crunch but the under-skilled youth who have bare minimum   education can also enter the job market with enhanced skills.</b> These trained youth not only become   socially, economically and financially independent but they also contribute towards their family   income like education of their siblings and hence breaking the loop of poverty and illiteracy. 

                          </p>
                          <p class="mb-2  fw-500 text-justify">
                          <b> These students develop skills that boost their employment prospects and open them up to widen their career prospects in the organized sector. Our holistic approach has facilitated strong community presence and goodwill along with a cohesive community of the passed-out employed youth, a fiat in which we take pride with humility.</b>

                          </p>
                          <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read Less
                                </button>
                              </>
                          ):(
                            <>
                             <p class="mb-2 mt-20 fw-500 text-justify">
                                  {truncateText(" We started with a vision to create employable urban youth that can play an integral part in the financial machinery of their family and society at large. This visualization gave rise to two flagship programs of joining hands, “Skill Enhancement Program” & “Higher Education Scholarship program”. Both these programs are dedicated to carve a righteous path for underprivileged youth that can save them from the social vices. We are very responsive to the changing market scenario and industry specific standards. Our programs are designed in a way that is in complete sync with industry standards and are research based, that give transparency in all aspects...", 900)}
                                </p>
                                <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read More
                                </button>
                              </>
                            )}
                        </div>
                        </div>
                      </div>
                      <div
                        className="col-md-5 image_box "
                        style={{ padding: "0 12px" }}
                      >
                        <img src="/images/blog/enhance-employ.jpg" alt="" />
                        {/* <span className="blog-tag">{tag}</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* skills Enhancement Programme */}
        <section class="blog-single-area pt-50 pb-120 ">
          <div class="container">
            <div class="row g-4">
              <div class="col-lg-12 order-2 order-lg-1">
                <div class="blog__item blog-single__left-item shadow-none">
                  <div class="blog__content p-0 mt-20 wow fadeInDown">
                    {/* <h4 class="mt-20 mb-20  py-5 fs-30 fw-bold text-center">
                      Enhancing Employability
                    </h4> */}
                    <div class="blog__content p-0  ">
                      <div className="row align-items-center ">
                        <h4 class="mt-20  py-5 fs-30 fw-bold">
                          Skill Enhancement Programme
                        </h4>
                        <div
                          className="col-md-5 image_box "
                          style={{ padding: " 0 12px" }}
                        >
                          <img
                            src="/images/blog/skill-enhencement.jpg"
                            alt=""
                          />
                          {/* <span className="blog-tag">{tag}</span> */}
                        </div>
                        <div className="col-md-7  ">

                          <div className="md-pl-30">
                          <div className="content-wrapper">
                          {expandedSections.aboutProgram ? (
                              <>

                            <p class=" mb-2 mt-20  fw-500 text-justify">
                            Skill development is crucial for marginalized community youth for several important reasons. It provides a pathway to economic stability, social inclusion, and personal empowerment. Skills are essential for securing jobs in today's economy, particularly as many sectors prioritize specialized knowledge and competencies. Marginalized youth, often facing barriers such as limited access to education or professional networks, can increase their employability by acquiring in-demand skills. Starting operation in 2006, at the time promoting volunteering, it was in 2012 that the program ran its first pilot of bridge course on enhancing employability for the school drop-out population of young adults in Nizzamuddin basti. The pilot gave us the reinforcement that there was a definite need of bridging this deep crevice prevalent in the economically marginalized segments of society where the youth was falling off the radar of education by class 10th. Rudderless and directionless and often exposed to vices ranging from drug abuse to violence and hooliganism, we saw it as a huge threat to waste of a very crucial potential workforce. 

                            </p>
                            <p class="mb-2  fw-500 text-justify">
                            Armed with the learnings of our test and pilot program, we opened the first center in Meethapur Chowk, Badarpur in January 2015, with the first ever batch of only 21 students in  january 2015. Today the Project has reached out to 1935 beneficiaries and around 70% of them are gainfully employed. The beneficiaries are now not only financially independent themselves, but also are supporting the educational cost of their siblings and extending considerable support to their families. 

                            </p>
                            <p class="mb-2  fw-500 text-justify">
                            Our skill training module targets the gaps that the school drop outs have been struggling with to land entry level jobs. The module is designed with keeping in mind the needs of the ever-changing sectors. We focus on soft skills, financial literacy, English communications, basic math & interview skills. We have trainers who are industry experts and have heaps of experience in their respective fields. The curriculum is designed to target the gaps that come in the way of employability of these youth. 

                            </p>
                            <p class="mb-2  fw-500 text-justify">
                           <b> We have completed 81 batches and currently 82 & 83 batches are running. We have constantly and tirelessly identified and bridged the gaps in the marginalized communities and made them more job worthy.  </b> 
                            </p>
                            <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read Less
                                </button>
                              </>
                          ):(
                            <>
                             <p class="mb-2 mt-20 fw-500 text-justify">
                                  {truncateText(" Skill development is crucial for marginalized community youth for several important reasons. It provides a pathway to economic stability, social inclusion, and personal empowerment. Skills are essential for securing jobs in today's economy, particularly as many sectors prioritize specialized knowledge and competencies. Marginalized youth, often facing barriers such as limited access to education or professional networks, can increase their employability by acquiring in-demand skills. Starting operation in 2006, at the time promoting volunteering, it was in 2012 that the program ran its first pilot of bridge course on enhancing employability for the school drop-out population of young adults in Nizzamuddin basti. The pilot gave us the reinforcement that there was a definite need of bridging this deep crevice prevalent in the economically marginalized segments of society where the youth was falling off the radar of education by class 10th. Rudderless and directionless and often exposed to vices ranging from drug abuse to violence and hooliganism, we saw it as a huge threat to waste of a very crucial potential workforce. ...", 800)}
                                </p>
                                <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read More
                                </button>
                              </>
                            )}
                          
                         </div >
                           

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Higher Education Scholarship Programme */}
        <section class="blog-single-area pt-50 pb-120 sub-bg">
          <div class="container">
            <div class="row g-4">
              <div class="col-lg-12 order-2 order-lg-1">
                <div class="blog__item blog-single__left-item shadow-none">
                  <div class="blog__content p-0 mt-10 wow fadeInDown">
                    <div className="row align-items-center ">
                      <div className="col-md-7 ">
                        <h4 class=" py-3 fs-30 fw-bold ">
                          Higher Education Scholarship Programme
                        </h4>
                        <div className="pr-30">
                        <div className="content-wrapper">
                        {expandedSections.aboutProgram ? (
                              <>

                          <p class=" mb-2 mt-20  fw-500 text-justify">
                          While working with these marginalized communities it was observed that many drop outs happen because of the lack of funds for higher education. For many deserving students, finance becomes a major road block and they end up leaving studies eventually. As a part of our endeavor to fill all the gaps in the path of education, we have a scholarship program that  identifies, screens and eventually supports the students that need financial assistance. 

                          </p>
                          <p>
                          Taking off the burden of tuition, scholarships provide financial relief to meritorious students, and hence they are able to continue their education smoothly and create a better future. Scholarships can cover tuition fees, textbooks, and sometimes even living expenses, reducing the financial strain on students and their families. A small amount of support can open doors of prestigious universities and academic programmes for these students. 

                          </p>
                          <p class="mb-2  fw-500 text-justify">
                          <b>Joining hands has so far supported more than 700 students to complete their higher education and settle themselves in the job market.</b> We boast of having helped these students till the last leg of their studies and also thereafter. Our students have shown tremendous personal growth and high confidence levels. Our scholarship initiative works in many phases and at every step our hard working team members work with utmost precision and dedication. 


                           
                          </p>
                          <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read Less
                                </button>
                              </>
                          ):(
                            <>
                             <p class="mb-2 mt-20 fw-500 text-justify">
                                  {truncateText(" While working with these marginalized communities it was observed that many drop outs happen because of the lack of funds for higher education. For many deserving students, finance becomes a major road block and they end up leaving studies eventually. As a part of our endeavor to fill all the gaps in the path of education, we have a scholarship program that  identifies, screens and eventually supports the students that need financial assistance....", 700)}
                                </p>
                                <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read More
                                </button>
                              </>
                            )}
                          
                         </div >
                        </div>
                      </div>
                      <div
                        className="col-md-5 image_box "
                        style={{ padding: " 0 12px" }}
                      >
                        <img
                          src="/images/blog/career.jpeg"
                          alt=""
                        />
                        {/* <span className="blog-tag">{tag}</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* --------End joining hands Higher education Scholarship programme */}

        {/* This initiative will be carried in five phases to have more effectiveness. */}
        <section class="blog-single-area pt-50    ">
          <div class="container">
            <div class="row g-4">
              <div class="col-lg-12 order-2 order-lg-1">
                <div class="blog__item blog-single__left-item shadow-none wow fadeInDown">
                  <div className="container-fluid px-md-0  ">
                    <ScholarshipProgramme />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ---------------Hospitality skills development programme */}
        <section class="blog-single-area pb-120">
          <div class="container">
            <div class="row g-4">
              <div class="col-lg-12 order-2 order-lg-1">
                <div class="blog__item blog-single__left-item shadow-none">
                  <div class="blog__content p-0 mt-20 wow fadeInDown">
                    {/* <h4 class="mt-20 mb-20  py-5 fs-30 fw-bold text-center">
                      Enhancing Employability
                    </h4> */}
                    <div class="blog__content p-0  ">
                      <div class="blog__content p-0">
                        <div className="row align-items-center ">
                          <div className="col-md-7 ">
                            <h4 class="mt-20  py-2 fs-30 fw-bold">
                              Hospitality Skills Development Programme
                            </h4>
                            <p class=" mb-2 mt-20  fw-500 text-justify">
                            The hospitality industry is a major contributor to the global economy, understanding this very need our hospitality program was launched. Many sectors like hospitality offer jobs at all levels but due to the lack of trained and skilled minds they are unable to fill these positions, this is where we work our magic, we create exclusive training modules that focus on making these youth highly employable in this sector. Hospitality Skill Development Programme in Association with Le Meridien, New Delhi was a huge success. 
                            </p>
                            <p class="mb-2  fw-500 text-justify">
                              <b>The programme started in 2016 and ran for four years till 2020, and it was indeed an incredible journey. An intensive theory and practical knowledge session created youth that were ready for all departments of the hospitality industry. The placement percentage was as high as 90% each year. So far 100 girls have been trained and placed under this program. 
                              </b>
                            </p>
                          </div>
                          <div
                            className="col-md-5 image_box "
                            style={{ padding: " 0 12px" }}
                          >
                            <img
                              src="/images/blog/hospitality-infographic.jpg"
                              alt=""
                            />
                            {/* <span className="blog-tag">{tag}</span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        
        {/* -----others--- */}
        <section class="blog-single-area pt-50 pb-120 sub-bg   ">
          <div class="container">
            <div class="row g-4">
              <div class="col-lg-12 order-2 order-lg-1">
                <div class="blog__item blog-single__left-item shadow-none">
                  <div class="blog__content p-0 mt-10 wow fadeInDown">
                    <div className="row align-items-center ">
                    <div className="col-md-5 image_box ">
                        <img src="/images/blog/other-events.jpg" alt="" />
                        {/* <span className="blog-tag">{tag}</span> */}
                      </div>
                      <div className="col-md-7 mt-10 ">
                        <h4 class=" py-3 fs-30 fw-bold ">OTHERS</h4>
                        <div className="pr-30">
                          <p class=" mb-2 mt-20  fw-500 text-justify">
                            We organize various events and workshops for school
                            going children and youth with the purpose of
                            fostering sensitivity and creating social
                            consciousness amongst them.
                          </p>
                          <p class="mb-2  fw-500 text-justify">
                            <span className="arrow">
                              <i class="fa fa-angle-double-right "></i>
                            </span>
                            <b>INCEPTUM</b> : As an organization whose vision revolves
                            around the welfare of the youth, Joining Hands has
                            been successfully running INCEPTUM, A platform
                            targeted towards “BUDDING YOUTH, i.e. school
                            children, aiming at sensitizing them on challenges
                            faced in environmental space
                          </p>
                          <p class="mb-2  fw-500 text-justify">
                            <span className="arrow">
                              <i class="fa fa-angle-double-right"></i>
                            </span>
                            <b>Theater</b> : Joining Hands collaborates with renowned
                            theater groups to spread awareness about socially
                            relevant issues in schools and educational
                            institutions.
                          </p>
                          <p class="mb-2  fw-500 text-justify">
                            <span className="arrow">
                              <i class="fa fa-angle-double-right"></i>
                            </span>
                            <b>Workshops & Training</b> : We engage in conducting
                            capacity building workshops and training for various
                            stakeholders in the society on various social issues
                            such as Sexual Harassment of Women at workplace
                            (SHAWP), Protection of Children from Sexual Offenses
                            Act (POCSO) and Gender Sensitization, NGO Accounting
                            & Reporting, Aligning CSR & NGOs strategy, Relation
                            between People Management & Project Cycle,NGO legal
                            Framework & Requirements.
                          </p>
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Blog single area end here --> */}
      </main>
    </>
  );
};
export default Single;
